$(document).on('click', '.print-btn', () => $.print('#printTerms'))
